// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"beh_a bhy_b bhy_va bhy_rv bhy_rw bhy_vu","PanelFooter--link":"beh_b"};